/**
 * "Choose your native language" — asked once, while creating the account (after name/e-mail/password),
 * written in every language at once so nobody has to guess.
 */
import { READING_LOCALES, UI_LOCALES } from '@tc/domain';
import { Brand } from './Brand.tsx';
import { seal } from '../i18n.ts';

export const NATIVE_NAMES: Record<string, string> = {
  'sv-SE': 'Svenska',
  'zh-Hans': '简体中文',
  'zh-Hant': '繁體中文',
  en: 'English',
};

/** UI language for a content language (no Traditional Chinese UI yet: use Simplified). */
export const uiFor = (locale: string): string => (locale === 'zh-Hant' ? 'zh-Hans' : (UI_LOCALES as readonly string[]).includes(locale) ? locale : 'en');

export function LanguageStep({ onPick }: { onPick: (locale: string) => void }) {
  return (
    <main className="auth">
      <div className="auth-card lang-step">
        <Brand />
        <h1 className="lang-step-title">
          <span lang="zh-Hans">选择您的母语</span>
          <span lang="sv">Välj ditt modersmål</span>
          <span lang="en">Choose your native language</span>
        </h1>
        <div className="lang-tiles" role="list">
          {READING_LOCALES.map((l) => (
            <button key={l} role="listitem" className="lang-tile" onClick={() => onPick(l)} lang={l}>
              <span className={`seal seal-${l}`}>{seal(l)}</span>
              <span className="lang-tile-name">{NATIVE_NAMES[l]}</span>
            </button>
          ))}
        </div>
      </div>
    </main>
  );
}

/** Compact switcher (native names) for screens before/around sign-in. */
export function LanguageSwitch({ value, onChange }: { value: string; onChange: (uiLocale: string) => void }) {
  return (
    <div className="lang-switch" role="group" aria-label="Language / 语言 / Språk">
      {UI_LOCALES.map((l) => (
        <button key={l} type="button" lang={l} className={value === l ? 'on' : ''} aria-pressed={value === l} onClick={() => onChange(l)}>
          {NATIVE_NAMES[l]}
        </button>
      ))}
    </div>
  );
}
